export const CONSUMER_EMAIL_DOMAINS = [
    "aol.com",
    "att.net",
    "bellsouth.net",
    "bk.ru",
    "bol.com.br",
    "comcast.net",
    "daum.net",
    "fastmail.com",
    "freenet.de",
    "gmail.com",
    "gmx.com",
    "googlemail.com",
    "hotmail.com",
    "hushmail.com",
    "icloud.com",
    "inbox.ru",
    "laposte.net",
    "libero.it",
    "list.ru",
    "live.com",
    "lycos.com",
    "mac.com",
    "mail.com",
    "mail.ru",
    "me.com",
    "naver.com",
    "orange.fr",
    "outlook.com",
    "protonmail.com",
    "qq.com",
    "rediffmail.com",
    "sbcglobal.net",
    "schwab.com",
    "seznam.cz",
    "terra.com.br",
    "uol.com.br",
    "virgilio.it",
    "web.de",
    "yahoo.com",
    "yandex.com",
    "zoho.com",
];

/**
 * Determines if an email is a non-consumer email address
 * @param email - The email to check
 * @returns True if the email IS NOT a consumer email, false otherwise.
 */
export function isWorkEmail(email: string): boolean {
    const domain = email.toLowerCase().split("@")[1];
    if (!domain) {
        return false;
    }
    return !CONSUMER_EMAIL_DOMAINS.includes(domain);
}

/**
 * Determines if an email is a consumer email address
 * @param email - The email to check
 * @returns True if the email IS a consumer email, false otherwise.
 */
export function isConsumerEmail(email: string): boolean {
    const domain = email.toLowerCase().split("@")[1];
    if (!domain) {
        return false;
    }
    return CONSUMER_EMAIL_DOMAINS.includes(domain);
}
